import uniq from 'lodash/uniq';
import { createApi, createBaseQuery } from '@adv-frontend/modules-query';
import { getRequestContext } from '@/shared/lib/requestContext';
import type { GeoSuggestRequestParams } from './types/GeoSuggestRequestParams';
import type { GeoSuggestResponse } from './types/GeoSuggestResponse';
import { request } from './request';

const api = createApi({
    name: 'entities/geoSuggest/api/api',
    baseQuery: createBaseQuery(request),
    endpoints: (builder) => {
        return {
            GeoSuggest: builder.query<string[], GeoSuggestRequestParams | null>({
                query: (payload) => {
                    return {
                        method: 'GET',
                        params: {
                            types: 'geo',
                            lang: 'ru_RU',
                            print_address: 1,
                            strict_bounds: 0,
                            bbox: '37.14056770019528,55.466872554118716,38.07303229980466,56.0084407090783',
                            apikey: getRequestContext().yandexMapGeoSuggestAPIKey,
                            ...payload,
                            text: 'Россия, ' + (payload?.text ?? ''),
                        },
                    };
                },
                keepUnusedDataFor: 2147483,
                transformResponse: (response: GeoSuggestResponse): string[] =>
                    uniq(response.results?.map((item) => item.address.formatted_address) ?? []),
            }),
        };
    },
});

export const { useLazyGeoSuggestQuery } = api;
export const getGeoSuggest = api.endpoints.GeoSuggest.query;
